export default {"src":"/_next/static/media/arrow_24.29ca18ec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};